import { toSubmissionFields, companyFromEmail } from '../../services/userLookup';

/**
 * Build the exact set of keys `POST /submissions` accepts. Anything else is
 * stripped server-side, so form-only state (`recipientEmailList`, `maximType`,
 * ...) is filtered out here rather than shipped and discarded.
 */
function buildSubmission(form, recipient) {
  return Object.assign(
    {
      sender: form.sender || (form.senderInfo && form.senderInfo.fullName) || '',
      senderEmail: form.senderEmail,
      // Left empty on purpose -- the API resolves the display name itself.
      recipient: '',
      recipientEmail: recipient.email,
      maxim: form.maxim,
      message: form.message,
      senderCompany: companyFromEmail(form.senderEmail)
    },
    // Directory-sourced only. These must never come from user-editable input:
    // the API emails `recipientManagerEmail` when its own lookup comes back
    // empty, so a forged value would redirect that notification.
    toSubmissionFields(recipient, 'recipient'),
    toSubmissionFields(form.senderInfo, 'sender')
  );
}

/**
 * Send one High Five per selected recipient.
 *
 * A 200 means the submission is stored and emails fan out asynchronously, so a
 * successful call must never be retried.
 *
 * @param {Object} h5Form the submit form state
 * @returns {Promise<Array<Object>>} one response body per recipient
 */
export default async function postHighFives(h5Form) {
  const responses = await Promise.all(
    h5Form.recipients.map(async recipient => {
      const res = await window.fetch(process.env.REACT_APP_SUBMISSION_API, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${window.sessionStorage.accessToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildSubmission(h5Form, recipient))
      });

      // A non-2xx from API Gateway (401 from the authorizer, 5xx) can arrive
      // without a JSON body. Treat an unparseable response as a failure rather
      // than letting it throw past the caller's error handling.
      return res
        .json()
        .catch(() => ({ error: true, status: `Request failed with status ${res.status}` }));
    })
  );
  return responses;
}



// WEBPACK FOOTER //
// ./src/containers/SubmitForm/postHighFives.js